import { colorsPalettes } from "@similarweb/styles";
import { StyledInnerContainer } from "app/pages/sales-intelligence/sub-modules/table-actions-panel/components/BaseActivatedPanel/styles";
import TableActionsPanel from "app/pages/sales-intelligence/sub-modules/table-actions-panel/components/TableActionsPanel/TableActionsPanel";
import styled from "styled-components";

export const StyledInnerPanelContainer = styled(StyledInnerContainer)`
    & > *:first-child {
        margin-left: 16px;
    }

    & > *:not(:last-child) {
        margin-right: 4px;
    }
`;

export const StyledTableActionsPanel = styled(TableActionsPanel)`
    border-top: 1px solid ${colorsPalettes.carbon["50"]};
`;
